const processImageUpload = require('utils/processImageUpload');

exports.processProfileImageUploadFromEvent = (event, {
    heicErrorMode = 'throw',
    onStart,
    onComplete
} = {}) => {

    const options = {
        processingOptions: {
            heicErrorMode,
            compressionErrorMode: 'use-original',
            compressionOptions: {
                maxSizeMB: 5,
                fileType: 'image/jpeg'
            }
        },
        onStart,
        onComplete
    };

    if (heicErrorMode === 'throw') {
        options.emergencyErrorCodes = ['HEIC_CONVERSION_FAILED'];
    }

    return processImageUpload.fromEvent(event, options);
};

exports.processChatImageUploadFromEvent = (event, {
    onStart,
    onComplete
} = {}) => {

    return processImageUpload.fromEvent(event, {
        processingOptions: {
            heicErrorMode: 'throw',
            compressionErrorMode: 'use-original',
            compressionOptions: {
                maxSizeMB: 10,
                fileType: 'image/jpeg',
                shouldCompress: (file) => file.type !== 'image/gif'
            }
        },
        emergencyErrorCodes: ['HEIC_CONVERSION_FAILED'],
        onStart,
        onComplete
    });
};

exports.validateChatImageUploadFile = (file, {
    maxImageSizeMb = 10,
    mbInBytes = 1024 * 1024
} = {}) => {

    const acceptedFiletypes = ['bmp', 'tif', 'tiff', 'gif', 'jpeg', 'jpg', 'jif', 'jfif', 'jp2', 'jpx', 'j2k', 'j2c', 'fpx', 'pcd', 'png', 'heic', 'heif'];
    const match = file.name.split('.').pop();
    const ext = match ? match.toLowerCase() : '';

    if (!acceptedFiletypes.includes(ext)) {
        return {
            isValid: false,
            message: 'Invalid file type. Please select an image.'
        };
    }

    if (file.size > (maxImageSizeMb * mbInBytes)) {
        return {
            isValid: false,
            message: `File is too large (${(file.size / mbInBytes).toFixed(1)}MB). Maximum size is ${maxImageSizeMb}MB.`
        };
    }

    return {
        isValid: true,
        message: null
    };
};

exports.readImagePreviewUrl = (file) => {

    return new Promise((resolve, reject) => {

        const reader = new FileReader();

        reader.onloadend = () => resolve(reader.result);
        reader.onerror = () => reject(new Error('Failed to read image for preview.'));
        reader.readAsDataURL(file);
    });
};

exports.getChatImageProcessingErrorMessage = (error) => {

    if (error?.code === 'HEIC_CONVERSION_FAILED') {
        return 'Failed to convert HEIC image. Please try a different format.';
    }

    return 'An error occurred while processing the image.';
};

exports.prepareChatImageAttachmentFromEvent = async (event, {
    maxImageSizeMb = 10,
    mbInBytes = 1024 * 1024,
    onStart,
    onComplete
} = {}) => {

    let file = event.target.files[0];

    if (!file) {
        return {
            status: 'empty'
        };
    }

    const validationResult = exports.validateChatImageUploadFile(file, {
        maxImageSizeMb,
        mbInBytes
    });

    if (!validationResult.isValid) {
        return {
            status: 'invalid',
            message: validationResult.message
        };
    }

    const {
        file: processedFile,
        error
    } = await exports.processChatImageUploadFromEvent(event, {
        onStart,
        onComplete
    });

    if (error) {
        return {
            status: 'processing-error',
            error,
            message: exports.getChatImageProcessingErrorMessage(error)
        };
    }

    file = processedFile;

    try {
        return {
            status: 'ready',
            file,
            previewUrl: await exports.readImagePreviewUrl(file)
        };
    }
    catch (error) {
        return {
            status: 'preview-error',
            error,
            message: 'Failed to read image for preview.'
        };
    }
};

